import { Badge } from "reactstrap";

export const convertRPInputToIntValue = (value) => {
  if (!value) {
    return 0;
  }
  let numericValue = value
    .replace(/,/g, "")
    .replace(/ /g, "")
    .replace(".00", "");

  if (isNaN(numericValue) || numericValue < 0 || numericValue === "") {
    numericValue = 0;
  }

  if (numericValue.length > 1 && numericValue[0] === "0") {
    numericValue = numericValue.substring(1, numericValue.length);
  }

  return numericValue;
};

export const getStatusBadge = (statusData) => {
  return statusData !== null ? (
    <Badge color={statusData.color} pill>
      {statusData.nama_status}
    </Badge>
  ) : (
    <Badge color={"dark"} pill>
      Kosong
    </Badge>
  );
};

// leave the space so that it won't make the class not work when combined with other class
export const getDarkTableRow = (themeContext) => {
  return themeContext === "dark" ? " bg-transparent " : " ";
};

export const getDarkDropdown = (themeContext) => {
  return themeContext === "dark" ? " text-white " : " ";
};

export const getDarkInput = (themeContext) => {
  return themeContext === "dark" ? " bg-transparent text-white " : " ";
};

export const downloadFile = (response) => {
  const contentDisposition = response.headers['content-disposition'];
  const defaultFilename = 'downloaded_file';
  const filename = contentDisposition?.includes('filename=') 
    ? contentDisposition.split('filename=')[1].replace(/['"]/g, '')
    : defaultFilename;

  const contentType = response.headers['content-type'] || 'application/octet-stream';
  const file = new Blob([response.data], { type: contentType });
  const fileURL = URL.createObjectURL(file);

  const downloadLink = document.createElement('a');
  downloadLink.style.display = 'none';
  downloadLink.href = fileURL;
  downloadLink.target = '_blank';
  downloadLink.download = filename;
  
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);

  URL.revokeObjectURL(fileURL);
};


export const openPdfInNewTab = (res) => {
  const file = new Blob([res.data], { type: "application/pdf" });
  const fileURL = URL.createObjectURL(file);
  const newTab = window.open(fileURL, "_blank");
  if (!newTab) {
    console.error("Popup blocked. Please allow popups for this website.");
    URL.revokeObjectURL(fileURL);
  }
};

export const numberToText = (value) => {
    const numbers = {
      1: "Satu",
      2: "Dua",
      3: "Tiga",
      4: "Empat",
      5: "Lima",
      6: "Enam",
      7: "Tujuh",
      8: "Delapan",
      9: "Sembilan",
      10: "Sepuluh",
      11: "Sebelas",
      12: "Dua Belas",
      13: "Tiga Belas",
      14: "Empat Belas",
      15: "Lima Belas",
      16: "Enam Belas",
      17: "Tujuh Belas",
      18: "Delapan Belas",
      19: "Sembilan Belas",
      20: "Dua Puluh",
      30: "Tiga Puluh",
      40: "Empat Puluh",
      50: "Lima Puluh",
      60: "Enam Puluh",
      70: "Tujuh Puluh",
      80: "Delapan Puluh",
      90: "Sembilan Puluh",
      100: "Seratus",
    };

    if (numbers[value]) {
      return numbers[value];
    }

    if (value > 20 && value < 100) {
      const tens = Math.floor(value / 10) * 10;
      const ones = value % 10;
      return `${numbers[tens]} ${numbers[ones]}`;
    }

    return value.toString();
  };